import { UseMutationResult } from '@tanstack/react-query';
import React from 'react';

import { ErrorMessage, SuccessMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Loader } from '@eika/loader';

import { SetNewPinFromAccountIdRequest, SetNewPinRequest } from '@/react-query/hooks/mutation/use-set-new-pin';

import { SetPinSession } from '@generated-types';
import useText from '@hooks/use-text';

interface PinInvalidErrorProps {
    newPinInvalidError: string | undefined;
}

type SetNewPinResponse = void;

interface PinStatusMessageProps {
    newPinInvalidError: string | undefined;
    setPinQuery:
        | UseMutationResult<SetPinSession, Error, SetNewPinFromAccountIdRequest>
        | UseMutationResult<SetNewPinResponse, Error, SetNewPinRequest>;
}

const PinInvalidError = ({ newPinInvalidError }: PinInvalidErrorProps) => {
    return (
        <ErrorMessage
            id="replace-card-new-pin-entry-form__pin-invalid-error"
            text={newPinInvalidError}
            icon={IconTypes.LUKK_24}
        />
    );
};

const SetPinError = () => {
    const { pinChangeErrorText, pinChangeErrorClickPreviousText } = useText();

    return (
        <ErrorMessage
            id="replace-card-new-pin-entry-form__change-pin-error"
            text={`${pinChangeErrorText} ${pinChangeErrorClickPreviousText}`}
            icon={IconTypes.LUKK_24}
        />
    );
};

const SetPinSuccess = () => {
    const { pinSaveSuccessText } = useText();

    return (
        <SuccessMessage
            id="replace-card-new-pin-entry-form__change-pin-success"
            text={pinSaveSuccessText}
            icon={IconTypes.CHECKMARK_LISTE_24}
        />
    );
};

const Loading = () => {
    return <Loader />;
};

export const NewPinEntryStatusMessage = ({ newPinInvalidError, setPinQuery }: PinStatusMessageProps) => {
    if (newPinInvalidError) {
        return <PinInvalidError newPinInvalidError={newPinInvalidError} />;
    }

    if (setPinQuery?.isError) {
        return <SetPinError />;
    }

    if (setPinQuery?.isPending) {
        return <Loading />;
    }

    if (setPinQuery?.isSuccess) {
        return <SetPinSuccess />;
    }

    return null;
};
